import { AutoBreaksRules } from '../shared';

export type BreakLegislationDisplayInfo = {
  countsTowardRequiredBreak: boolean;
  breakTypeName?: string;
};

/**
 * Resolves whether a break counts toward legally required break time for UI (asterisk + tooltip).
 * Defaults to counting when metadata is missing or break type cannot be resolved.
 */
export const getBreakLegislationDisplayInfo = (
  rules: AutoBreaksRules | null,
  breakTypeId: string | null | undefined,
): BreakLegislationDisplayInfo => {
  const meta = rules?.breakTypesLegislation;
  if (!meta?.length) {
    return { countsTowardRequiredBreak: true };
  }

  let effectiveId = breakTypeId ?? undefined;
  if (!effectiveId && meta.length === 1) {
    effectiveId = meta[0].id;
  }
  if (!effectiveId) {
    return { countsTowardRequiredBreak: true };
  }

  const found = meta.find((x) => x.id === effectiveId);
  if (!found) {
    return { countsTowardRequiredBreak: true };
  }

  return {
    countsTowardRequiredBreak: found.countsTowardRequiredBreak,
    breakTypeName: found.name,
  };
};
